import React from "react";
import PropTypes from "prop-types";

export default class InfiniteScroll extends React.Component {
    componentDidMount() {
        $(window).scroll(() => {
            if ($(window).scrollTop() >= $(document).height() - $(window).height() - this.props.offset) {
                this.props.onNextLoad && this.props.onNextLoad();
            }
        });
    }

    render() {
        return this.props.children;
    }
}

InfiniteScroll.propTypes = {
    onNextLoad: PropTypes.func.isRequired,
    offset: PropTypes.number
};

InfiniteScroll.defaultProps = {
    offset: 60
};
